import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useCallback } from 'react';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';
import { useSetActiveEventPanelTab } from '../active-event-panel-tab-provider';

export function AssociateEventMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const setActiveEventPanelTab = useSetActiveEventPanelTab();

    const handleSuccess = useCallback(() => {
        setActiveEventPanelTab('EVENT_DETAILS');
    }, [setActiveEventPanelTab]);

    const handleSelect = (): void => {
        modalControls.open({
            type: 'ASSOCIATE_EVENT',
            props: { agencyEventId: clickParams.eventId, onSuccess: handleSuccess },
        });
    };

    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
